import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToBottom() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(10, 10);
  }, [pathname]);

  return null;
}
